import Lottie from 'lottie-react';

import { cn } from '@/lib/utils';

import rejectAnimation from './RejectAnimation.json';

interface RejectAnimationProps {
    className?: string;
    loop?: boolean;
}

export default function RejectAnimation({ className, loop = true }: RejectAnimationProps) {
    return (
        <Lottie
            animationData={rejectAnimation}
            loop={loop}
            className={cn('h-full w-full', className)}
        />
    );
}
